<template lang="pug">
  .shoppingTimelineSlide.blue-background(ref="shoppingTimeline")
    .max-width-grid
      h4.white What is the timeline for holiday shopping?<span class="super"><a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">2</a></span>
      .chart-wrap
        ShoppingTimeline.desktop
        ShoppingTimelineMobile.mobile
        .text-block.one
          p.p2 <span class="bold">Tuesday</span><br>Dec. 18
        .text-block.two
          p.p2 <span class="bold">Wednesday</span><br>Dec. 19
        .text-block.three
          p.p2 <span class="bold">Thursday</span><br>Dec. 20
        .text-block.four
          p.p2 <span class="bold">Friday</span><br>Dec. 21
        .text-block.five
          p.p2 <span class="bold">Saturday</span><br>Dec. 22
        .text-block.six
          p.p2 <span class="bold">Sunday</span><br>Dec. 23
        .text-block.seven
          p.p2 <span class="bold">Monday</span><br>Dec. 24
        .text-block.eight
          p.p2 <span class="bold">Tuesday</span><br>Dec. 25
      .text-wrap
        p.descript The most popular day to shop online was Cyber Monday, with  <span class="bold">67.4 million shoppers</span>, followed by Black Friday, with <span class="bold">65.2 million shoppers</span>. The most popular day for in-store shopping was Black Friday, with more than <span class="bold">67 million shoppers</span>, followed by Small Business Saturday, with <span class="bold">47.4 million shoppers</span>.<span class="super"><a href="https://nrf.com/media-center/press-releases/thanksgiving-weekend-multichannel-shopping-almost-40-percent-over-last " target="_blank">1</a></span>
        p.descript The five-day period from Thanksgiving through Cyber Monday accounted for <span class="bold">$1 in $5</span> of total online retail revenue during the holidays. Consumers spent an average <span class="bold">40% more per day</span> during the three weeks after Cyber Monday than the first three weeks of the season.<span class="super"><a href="https://cmo.adobe.com/articles/2019/1/5-holiday-online-shopping-trends-to-guide-your-2019-strategy.html" target="_blank">5</a></span>

</template>

<script>
import ShoppingTimeline from '@/assets/img/barCharts/shoppingTimeline.svg'
import ShoppingTimelineMobile from '@/assets/img/barCharts/shoppingTimelineMobile.svg'

export default {
  name: 'shoppingTimelineSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const getDesktopBars = this.$el.querySelectorAll('.barMobile')
    const getMobileBars = this.$el.querySelectorAll('.barDesktop')
    const mobileHeights = [...getMobileBars].map(el => el.getAttribute('height'))
    const mobileYVal = [...getMobileBars].map(el => el.getAttribute('y'))
    const desktopHeights = [...getDesktopBars].map(el => el.getAttribute('height'))
    const dekstopYVal = [...getDesktopBars].map(el => el.getAttribute('y'))

    this.mobileTimeline = new TimelineLite({ paused: true })
    this.timeline = new TimelineLite({ paused: true })

    getDesktopBars.forEach((bar, i) => {
      let height = parseFloat(desktopHeights[i])
      let y = parseFloat(dekstopYVal[i])
      let animateFrom = height + y
      this.timeline.fromTo(bar, 1, {attr: { y: animateFrom, height: 0 } }, {attr:{ y: dekstopYVal[i], height: desktopHeights[i] } }, '-=0.75')
    })
   
    getMobileBars.forEach((bar, i) => {
      let height = parseFloat(mobileHeights[i])
      let y = parseFloat(mobileYVal[i])
      let animateFrom = height + y
      this.mobileTimeline.fromTo(bar, 1, {attr: { y: animateFrom, height: 0 } }, {attr:{ y: mobileYVal[i], height: mobileHeights[i] } }, '-=0.75')
    })
  },
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
      this.mobileTimeline.seek(0)
      this.mobileTimeline.play()
    },
  },
  components: {
    ShoppingTimeline,
    ShoppingTimelineMobile,
  },
}
</script>

<style scoped lang="scss">
.shoppingTimelineSlide {
  padding-top: 5rem;
  height: 78rem;
  color: #fff;

  h4 {
    text-align: center;
    padding-bottom: 8rem;
  }

  .super {
    a {
      color: #fff;
    }
  }

  .chart-wrap,
  .text-wrap {
    width: 73%;
    margin: 0 auto;
  }

  .chart-wrap {
    padding-bottom: 7.25rem;
  }

  .descript {
    display: inline-block;
    vertical-align: top;
    width: 46%;
    &:first-of-type {
      padding-right: 4%;
      width: 50%;
    }
  }

  .text-block {
    top: 47%;
    text-align: center;
    &.one { left: 16%; }
    &.two { left: 24%; }
    &.three {  left: 34.5%; }
    &.four { left: 44.5%; }
    &.five { left: 53%; }
    &.six { left: 62%; }
    &.seven { left: 71.5%; }
    &.eight { left: 80.5%; }
  }

  @media #{$mobile} {
    h4 {
      padding-bottom: 4rem;
    }
  
    .chart-wrap {
      padding-bottom: 8rem;
      width: 84%;
    }
    
    .text-wrap {
      width: 85%;
    }

    .descript {
      width: 50%;
      &:first-of-type {
        padding-right: 4%;
        width: 50%;
      }
    }

    .text-block {
      &.one { left: 11.5%; }
      &.two { left: 22%; }
      &.three {  left: 32.5%; }
      &.four { left: 43%; }
      &.five { left: 52.5%; }
      &.six { left: 62.5%; }
      &.seven { left: 72.5%; }
      &.eight { left: 83.5%; }
    }

  }
}
</style>
